__turbopack_context__.v({
  "burgerbutton": "HeraHeader-module-scss-module__K-Q40G__burgerbutton",
  "heraheader": "HeraHeader-module-scss-module__K-Q40G__heraheader",
  "items": "HeraHeader-module-scss-module__K-Q40G__items",
  "logoIcon": "HeraHeader-module-scss-module__K-Q40G__logoIcon",
  "logoIcon1": "HeraHeader-module-scss-module__K-Q40G__logoIcon1",
  "navLink": "HeraHeader-module-scss-module__K-Q40G__navLink",
  "navbarMenu": "HeraHeader-module-scss-module__K-Q40G__navbarMenu",
  "open": "HeraHeader-module-scss-module__K-Q40G__open",
  "sidebarBtn": "HeraHeader-module-scss-module__K-Q40G__sidebarBtn",
  "sidebarContent": "HeraHeader-module-scss-module__K-Q40G__sidebarContent",
  "sidebarWrapper": "HeraHeader-module-scss-module__K-Q40G__sidebarWrapper",
  "userBar": "HeraHeader-module-scss-module__K-Q40G__userBar",
});
